import React, { Component } from 'react';
import SocialContainer from './react.SocialContainer'; 
import Carousel from './Carousel';
import '../Assets/Styles/Modal.css';


import classNames from 'classnames'


class Modal extends Component {

  constructor() {
    super();
    this.state = {
      activeModal: null,
      videoSlides: null,
      gallerySlides: null,
    }
  }

  handleClick() {
    this.setState({
      activeModal: null
    });
  }

  componentDidMount() {
    this.setState({
      videoSlides: [
        "2WhQcK-Zaok",
        "dW1BIid8Osg",
        "eX0KjDFvDAY",
        "wUn05hdkhjM",
        "0LWEYReXjQs",
        "MTrLaWIcdAs",
        "BSXAOywn_rE"

        // "wUn05hdkhjM",
        // "eX0KjDFvDAY",
        // "dW1BIid8Osg",
        // "2WhQcK-Zaok"
      ],
      gallerySlides: [
        'https://i.annihil.us/u/prod/avengersmovie/guardians/static/media/01.6a4714ff.jpg',
        'https://i.annihil.us/u/prod/avengersmovie/guardians/static/media/02.9d1e123c.jpg',
        'https://i.annihil.us/u/prod/avengersmovie/guardians/static/media/03.d1c0b9c6.jpg',
        'https://i.annihil.us/u/prod/avengersmovie/guardians/static/media/04.c0331f49.jpg',
        'https://i.annihil.us/u/prod/avengersmovie/guardians/static/media/05.3611fcb6.jpg',
        'https://i.annihil.us/u/prod/avengersmovie/guardians/static/media/06.58678c84.jpg',
        'https://i.annihil.us/u/prod/avengersmovie/guardians/static/media/07.7f8e91d9.jpg',
        'https://i.annihil.us/u/prod/avengersmovie/guardians/static/media/08.0b526872.jpg',
        'https://i.annihil.us/u/prod/avengersmovie/guardians/static/media/09.07e63f93.jpg',
        'https://i.annihil.us/u/prod/avengersmovie/guardians/static/media/10.35e82e11.jpg',
        'https://i.annihil.us/u/prod/avengersmovie/guardians/static/media/11.f0793ce3.jpg',
        'https://i.annihil.us/u/prod/avengersmovie/guardians/static/media/12.ec948d7f.jpg',
        'https://i.annihil.us/u/prod/avengersmovie/guardians/static/media/13.d6939ffb.jpg',
        'https://i.annihil.us/u/prod/avengersmovie/guardians/static/media/14.56fc1186.jpg'
      ]
    });
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      activeModal: nextProps.activeModal
    })
  }

  isActive(modal) {
    return (modal === this.state.activeModal)
  }

  render() {
    let videoSlides = this.state.videoSlides;
    let gallerySlides = this.state.gallerySlides;
    let activeModal = this.state.activeModal


    let classes = classNames({
      'ModalContainer': true,
      'active': activeModal !== null && activeModal !== '' && (activeModal !== 'partners' || activeModal !== 'characters')
    })

    let trailerClasses = classNames({
      'trailersContent': true,
      active: this.isActive('trailersModal')
    })

    let galleryClasses = classNames({
      'galleryContent': true,
      active: this.isActive('galleryModal')
    })

    // console.log(activeModal)
    return (
      <div className={classes + " " + activeModal}>
        <header>
          <SocialContainer />
          <h1 className="modalTitle"></h1>
          <span className="character-close-button" onClick={this.props.closeModal.bind(this)}></span>
        </header>
        <div className={"Modal " + activeModal}>
          <article>
            <div className={trailerClasses}>
              <Carousel slides={videoSlides} format="videos" active={this.isActive('trailersModal')}/>
            </div>

            <div className="synopsisContent">
              <h3 className="synopsisTitle"></h3>
              <p>Set to the all-new sonic backdrop of Awesome Mixtape #2, Marvel Studios’ “Guardians of the Galaxy Vol. 2” continues the team’s adventures as they traverse the outer reaches of the cosmos. The Guardians must fight to keep their newfound family together as they unravel the mystery of Peter Quill’s true parentage. Old foes become new allies and fan-favorite characters from the classic comics will come to our heroes’ aid as the Marvel Cinematic Universe continues to expand.</p>  
              <p>“Guardians of the Galaxy Vol. 2” is written and directed by James Gunn and stars Chris Pratt, Zoe Saldana, Dave Bautista, featuring Vin Diesel as Baby Groot, Bradley Cooper as Rocket, Michael Rooker, Karen Gillan, Pom Klementieff, Elizabeth Debicki, Chris Sullivan, Sean Gunn, Tommy Flanagan, Laura Haddock, with Sylvester Stallone, and Kurt Russell. Kevin Feige is producing, and Louis D’Esposito, Victoria Alonso, Jonathan Schwartz, Nikolas Korda and Stan Lee are the executive producers. Marvel Studios’ “Guardians of the Galaxy Vol. 2” blasts into theaters on May 5, 2017.</p>
            </div>

            <div className={galleryClasses}>
              <Carousel slides={gallerySlides} format="images" active={this.isActive('galleryModal')}/>
            </div>
          </article>
        </div>
      </div>
    );
  }
}

export default Modal;


// WEBPACK FOOTER //
// ./src/Components/Modal.js